import { colors } from '../constants';
const styleOverrides = {
  sizeLarge: {
    padding: '14px 23px',
    lineHeight: 1.25
  },
  sizeSmall: {
    padding: '10px 23px'
  },
  sizeMedium: {
    padding: '12px 23px'
  },
  root: {
    lineHeight: 1.3,
    borderRadius: 25
  },
  text: {
    padding: '10px 23px'
  },
  textPrimary: {
    '&:hover,&:focus': {
      color: colors.primary.main
    }
  },
  textSecondary: {
    '&:hover,&:focus': {
      color: colors.secondary.main
    }
  },
  contained: {
    borderRadius: 25,
    '&$disabled': {
      color: colors.commonColors.white
    }
  },
  containedPrimary: {
    '&:hover,&:focus': {
      color: colors.primary.contrastText
    }
  },
  containedSecondary: {
    '&:hover,&:focus': {
      color: colors.secondary.contrastText
    }
  },
  outlined: {
    borderRadius: 25,
    padding: '10px 23px',
    lineHeight: 1.35
  },
  outlinedPrimary: {
    '&:hover,&:focus': {
      color: colors.primary.main
    }
  },
  outlinedSecondary: {
    '&:hover,&:focus': {
      color: colors.secondary.main
    }
  }
};
const defaultProps = {
  disableElevation: true,
  color: 'default'
};
const variants = [{
  props: {
    color: 'frontPage'
  },
  style: {
    backdropFilter: 'blur(30px)',
    color: colors.commonColors.white
  }
}, {
  props: {
    variant: 'outlined',
    color: 'default'
  },
  style: {
    color: colors.oriGrey[900],
    border: `1px solid ${colors.oriGrey.A400}`,
    '&:hover,&:focus': {
      color: colors.oriGrey[900],
      border: `1px solid ${colors.oriGrey[900]}`
    }
  }
}, {
  props: {
    variant: 'contained',
    color: 'superApp'
  },
  style: {
    background: `linear-gradient(90deg, ${colors.superApp.light} 0%, ${colors.superApp.main} 100%)`
  }
}, {
  props: {
    variant: 'contained',
    color: 'superApp',
    disabled: true
  },
  style: {
    '&.Mui-disabled': {
      background: '#DDDDDD',
      color: colors.commonColors.white
    }
  }
}, {
  props: {
    variant: 'outlined',
    color: 'superApp'
  },
  style: {
    borderWidth: '3px',
    borderColor: colors.superApp.main,
    '&:hover,&:focus': {
      borderWidth: '3px'
    }
  }
}, {
  props: {
    variant: 'outlined',
    color: 'superApp',
    size: 'large'
  },
  style: {
    padding: '11px 20px'
  }
}, {
  props: {
    variant: 'outlined',
    color: 'superApp',
    size: 'small'
  },
  style: {
    padding: '7px 20px'
  }
}, {
  props: {
    variant: 'outlined',
    color: 'superApp',
    size: 'medium'
  },
  style: {
    padding: '9px 20px'
  }
}];
export default {
  defaultProps,
  styleOverrides,
  variants
};